import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import PaymentMethodUpdate from '../PaymentMethodUpdate/PaymentMethodUpdate.vue'
import PaymentMethodDelete from '../PaymentMethodDelete/PaymentMethodDelete.vue'
import { VBTooltip } from 'bootstrap-vue'

@Component({
  computed: {
    ...mapGetters('user', ['team'])
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  components: {
    PaymentMethodUpdate,
    PaymentMethodDelete,
  }
})
export default class PaymentMethod extends Vue {
  team!: KwixeoFramework.Team

  @Prop({ default: false }) cantDelete!: boolean|undefined

  get subscription (): KwixeoSubscriptions.TeamSubscription {
    return this.team.subscription as KwixeoSubscriptions.TeamSubscription
  }

  get subscriptionStatus (): boolean {
    return this.subscription.status
  }
}
